import { Box, styled, Typography } from "@mui/material";
import { TEXT_ELLIPSIS } from "@shared/styles";
import Stack from "@mui/material/Stack";

const TEXT_STYLE = {
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--community-color-primary-text)",
    lineHeight: 1,
};

export const FIRST_ROW_HEIGHT = "52px";

export const GameTitle = styled(Typography)({
    ...TEXT_STYLE,
    ...TEXT_ELLIPSIS,
    lineHeight: 1.5,
    width: "100%",
    textAlign: "center",
    alignContent: "center",
});

export const GameClockTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "inProgress",
})<{ inProgress: boolean }>(({ inProgress }) => ({
    fontWeight: 400,
    color: inProgress
        ? "var(--community-active-game-in-progress)"
        : TEXT_STYLE.color,
}));

export const GameStateInfo = styled(Stack)({
    flexDirection: "row",
    marginBottom: "16px",
    width: "100%",
    ...TEXT_STYLE,
    gap: "4px",
});

export const TeamInfoContainer = styled(Stack)({
    display: "flex",
    justifyContent: "start",
    flexDirection: "column",
    overflow: "hidden",
});

export const GameInfoContainer = styled(Stack)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "63px",
});

export const GameInfoFirstRow = styled(Box)({
    height: FIRST_ROW_HEIGHT,
    minHeight: FIRST_ROW_HEIGHT,
    display: "flex",
    alignItems: "center",
});

export const TeamIconContainer = styled(Box)({
    width: "36px",
    minWidth: "36px",
    height: "36px",
    margin: "8px 0",
    display: "none",
    "@media (min-width: 375px)": {
        display: "block",
    },
});

export const GameScore = styled(Typography)({
    fontWeight: 700,
    justifySelf: "center",
    alignSelf: "center",
    color: TEXT_STYLE.color,
});

export const GameHeaderContainer = styled(Box)({
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
});

export const IconContainer = styled(Box)({
    width: "40px",
    minWidth: "40px",
    height: "40px",
    marginRight: "12px",
});

export const LeagueImage = styled("img")({
    borderRadius: "4px",
    display: "block",
    width: "100%",
    height: "100%",
});

export const Subtitle = styled(Typography)({
    ...TEXT_STYLE,
    lineHeight: 1.5,
    color: "var(--community-color-secondary-text)",
    fontSize: "12px",
    ...TEXT_ELLIPSIS,
});

export const GameTitleRightColumn = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    ...TEXT_ELLIPSIS,
});

export const InProgressAnimation = styled(Box)({
    height: "2px",
    background:
        "no-repeat linear-gradient(var(--community-active-game-in-progress) 0 0), none",
    backgroundSize: "60% 100%",
    animation: "l16 3s infinite",
    "@keyframes l16": {
        "0%": { backgroundPosition: "-110% 0" },
        "50%": { backgroundPosition: "210% 0" },
        "100%": { backgroundPosition: "-110% 0" },
    },
});

export const CountdownTypography = styled(Typography)({
    ...TEXT_STYLE,
    color: "var(--community-color-secondary-text)",
});
